













import { defineComponent } from '@nuxtjs/composition-api';
import { BaseHeading } from '@shared/ui';

import TruncatedReadMoreTextContainer from '~/components/TruncatedReadMoreTextContainer/TruncatedReadMoreTextContainer.vue';

export default defineComponent({
  name: 'PageHeroDescription',
  components: {
    BaseHeading,
    TruncatedReadMoreTextContainer,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    titleHeading(): string {
      return `${this.title} Products`;
    },
  },
});
